// Product scoping hides modules for products the rooftop does not hold. `appointments` is not a
// product, so it follows its config switch.

import type { PortalProducts } from '@features/products/types';
import { isProductHeld } from '@features/products/productGates';

import type { ModuleFeature } from '../types';

interface EffectiveConfig {
  appointments?: { enabled?: boolean };
}

/** Undefined until the products load. */
export type ProductEntries = PortalProducts['entries'] | undefined;

export function enabledProductFeatures(entries: ProductEntries, effectiveConfig: unknown): ModuleFeature[] {
  const cfg = (effectiveConfig ?? {}) as EffectiveConfig;
  const enabled: ModuleFeature[] = [];
  if (isProductHeld(entries?.['mobile-service'])) enabled.push('mobile_service');
  if (isProductHeld(entries?.['guest-rides'])) enabled.push('guest_ride');
  if (isProductHeld(entries?.appraisals)) enabled.push('appraisals');
  if (cfg.appointments?.enabled === true) enabled.push('appointments');
  return enabled;
}
